import React from "react";

const TextArea = ({ field, title, form, label, maxLength = 500, ...props }) => {
  const currentLength = field.value?.length || 0;

  return (
    <div className="flex flex-col gap-2 mt-4">
      {label && (
        <p htmlFor={field.name} className="text-[20px] font-[500]">
          {title}
        </p>
      )}

      <div className="flex justify-between items-center w-full">
        <span>{label}</span>
        <span>
          Caracteres: {currentLength}/{maxLength}
        </span>
      </div>

      <textarea
        {...field}
        {...props}
        id={field.name}
        maxLength={maxLength}
        rows={5}
        className="p-3 rounded-[4px] border-[2px] border-nemu-plata"
      />
    </div>
  );
};

export { TextArea };